
<template>
    <div class="ibox">
      	<div class="ibox-content">
            <div class="row" v-if="mode==='standard'" style="padding-left: 5px!important;">
                <div class="col-12">
                    <p class="m-b-none m-t-xs"><i>{{ __('price_list_show_create_row_1')}}<br/>
                        {{ __('price_list_show_create_row_2')}}<br/>
                        {{ __('price_list_show_create_row_3')}}
                    </i></p>
                </div>
            </div>
        		<div class="prices-table table-tranfers">
          			<div>
            				<div class="d-flex flex-row">
                        <table>
                            <thead class="" v-if="mode == 'standard'">
                                <th class="price-column-name th-first text-capitalize" :class="{'th-last' : tariffs_test.length == 0}">{{ __('tariff')}}</th>
                                <th class="price-column" v-for="(tariff, key) in tariffs_test" v-bind:class="[tariffs_test.length -1  == key ?'th-last' : '']">
                                    <span>{{tariff.name}}</span>
                                </th>
                            </thead>
                            <tbody>
                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell" >{{ __('tariff_type')}}</td>
                                    <td class="price-column table-cell" v-for="tariff in tariffs_test">
                                        <span>{{__(tariff.type)}}</span>
                                    </td>
                                </tr>
                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell">{{ __('contract_or_settlement_period')}}</td>
                                    <td v-if="!read_only && tariff.type != 'surcharge'" class="price-column table-cell" v-for="tariff in tariffs_test">
                                        <span>{{__(tariff.billing_period)}}</span>
                                    </td>
                                    <td v-else-if="!read_only" class="prices-disabled"></td>
                                    <td v-else="">
                                        <span v-if="isEmpty(tariff.billing_period)"><i class="fas fa-minus"></i></span>
                                        <span v-else>{{__(tariff.billing_period)}}</span>
                                    </td>
                                </tr>
                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell">{{ __('max_doc_monthly')}}</td>
                                    <td class="price-column table-cell" v-for="tariff in tariffs_test">
                                        {{tariff.max_documents_monthly}}
                                    </td>
                                </tr>
                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell">{{ __('max_users')}}</td>
                                    <td  class="price-column table-cell" v-for="tariff in tariffs_test">
                                        {{tariff.max_users}}
                                    </td>
                                </tr>

                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell">{{ __('add_department_possibility')}}</td>
                                    <td v-if="enableAddDepartmentField(tariff) && !read_only" class="price-column table-cell text-uppercase" v-for="tariff in tariffs_test">
                                        {{__(addDepartmentsAbility(tariff))}}
                                    </td>
                                    <td v-else-if="!enableAddDepartmentField(tariff) && !read_only" class="prices-disabled"></td>
                                    <td v-else><span v-if="tariff.many_departments == 0"><i class="fas fa-minus"></i></span><span v-else><i class="fas fa-check"></i></span></td>
                                </tr>

                                <tariff-services
                                  v-for="service in services"
                                  ref="tariff_service"
                                  :service="service"
                                  :key="service.id"
                                  :tariffs="tariffs_test"
                                  :tariff_price_details="tariff_price_details"
                                  :validated_form="validated_form"
                                  :read_only="read_only"
                                  :mode="mode"
                                  @nonTariffChange="nonTariffChange"
                                  :action="action"/>
                                <tr v-if="mode == 'standard'">
                                    <td class="price-column-name table-cell service-name" colspan="100%">Naliczenia</td>
                                </tr>

                                <tariff-input-row v-if="mode == 'standard'"
                                  :row_name="__('each_next_document')"
                                  input_name="charge_next_document"
                                  :tariffs="tariffs_test"
                                  model_prop="charge_next_document"
                                  :action="action"
                                  :read_only="read_only"
                                  :validated_form="validated_form"/>
                                <tariff-input-row v-if="mode == 'standard'"
                                  :row_name=" __('each_next_user')"
                                  input_name="charge_next_user"
                                  :tariffs="tariffs_test"
                                  model_prop="charge_next_user"
                                  :action="action"
                                  :read_only="read_only"
                                  :validated_form="validated_form"/>
                                <tariff-row-delete
                                  v-if="!read_only && mode !='no_tariff' && price_list_type != 'mother' && price_list_complete && type !='special' && type !='standard'"
                                  row_name=""
                                  :tariffs="tariffs_test"
                                  :route_tariff_destroy="route_tariff_destroy"
                                  :csrf_token="csrf_token"/>
                            </tbody>
                        </table>
            				</div>
          			</div>
        		</div>
      	</div>
    </div>
</template>

<script>
import TariffServices from './table/tariffServices';
import TariffInputRow from './table/tariffInputRow';
import TariffRowDelete from './table/tariffRowDelete';
import Utils from './../../services/Utils.js';
import {mapGetters} from 'vuex';
import Vue from "vue";
import {Money} from "../../services/Money";


export default {
    components : {
      TariffServices,
      TariffInputRow,
      TariffRowDelete,
    },
    data : () => ({
        price_list_type:'none',
        price_list_complete:true,
    }),
    props : [
      'services',
      'tariffs',
      'route_tariff_destroy',
      'csrf_token',
      'tariff_details',
      'tariff_price_details',
      'validated_form',
      'read_only',
      'action',
      'mode',
        'type'
    ],
    computed : {
       serviceDetail : function () {
            return service;
        },
       last(){
          return Object.keys(this.tariffs).length-1;
       },
       ...mapGetters({tariffs_test : 'getTariffsData'})
    },
    methods : {
        addDepartmentsAbility : function (tariff) {
           return tariff.many_departments == true ? 'yes' : 'no';
        },
        enableAddDepartmentField(tariff) {
          return  ['subscription', 'free', 'pre_paid'].includes(tariff.type);
        },
        isEmpty(value) {
            return Utils.isEmpty(value);
        },
        nonTariffChange(value){
            this.$emit('nonTariffChange', value)
        }
    },
    mounted : function () {
    }

}
</script>

<style>
  input[type=checkbox], input[type=radio] {
    box-sizing: border-box;
    padding: 0;
    height: 13px;
    width: 13px;
  }
  .table-cell {
    display: table-cell;
  }

  .prices-table .price-column-name {
    border-bottom: 1px solid #e0e0e0;
    padding:6px;
    vertical-align: middle;
    text-align: center;
  }
  .prices-disabled {
    background-color: #eae8e8;
  }
  .service-name {
    background-color: #dedbdb;
  }
  .price-column-name {
    min-width: 300px;
    text-align: left!important;
    font-weight: 700;
    color: #495966;
  }
  .price-column {
    min-width: 110px;
    max-width: 110px;
  }

  .prices-table {
    overflow-x: scroll;
    border-bottom: 1px solid #e0e0e0;
    line-height: 1.42857;
    padding: 6px;
    vertical-align: middle;
    text-align: center;
  }
  .th-first {
  	padding-top: 4px!important;
    padding-bottom: 0px!important;
  }
  .th-first{
    padding: 6px !important;

  }
  .thead {
    background-color: #fafafa;
    color: #495966;
    font-weight: 700;
    	content:'';
        left: 0;
        top: 0;
        width:100%;
    	height: 100%;
        border-bottom: 1px solid #495966!important;
        border-top: 1px solid #495966;
        z-index:-1;
  }
  thead th {
    top: 0px;
  }
  .prices-table td {
      display: table-cell;
      border-bottom: 1px solid #e0e0e0;
      line-height: 1.42857;
      padding: 6px;
      vertical-align: middle;
      text-align: center;
  }
  .prices-table .form-control {
    text-align: center;
    max-width: 90px;
    margin: auto;
    height: 24px;
    font-size: 11px;
  }
</style>
